export const hoverSupported = () => {
  return window.matchMedia('(hover: hover) and (pointer: fine)').matches
}
